import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";
import { DateFromDateOrIsoStringSchema } from "./date-schema";

const RedoFulfillmentToteSchema_ = z
  .object({
    _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
    createdAt: DateFromDateOrIsoStringSchema.meta({ privacy: privacy.nonPii }),
    updatedAt: DateFromDateOrIsoStringSchema.meta({ privacy: privacy.nonPii }),
    team: zExt.objectId().meta({ privacy: privacy.nonPii }),
    name: z.string().meta({ privacy: privacy.nonPii }),
    barcode: z.string().meta({ privacy: privacy.nonPii }),
    barcodeUrl: z.string().meta({ privacy: privacy.null }).nullish(),
    pickSessionId: z.string().meta({ privacy: privacy.nonPii }).nullish(),
    toteGroupId: zExt.objectId().meta({ privacy: privacy.nonPii }).nullish(),
    locationId: locationIdFormat.schema
      .meta({ privacy: privacy.nonPii })
      .nullish(),
  })
  .meta({ privacy: privacy.structured });
export const RedoFulfillmentToteSchema: z.ZodType<RedoFulfillmentTote> =
  RedoFulfillmentToteSchema_;

export interface RedoFulfillmentTote extends z.infer<
  typeof RedoFulfillmentToteSchema_
> {}
